/* SLIDE 5 */

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import parkingStatusIcon from "assets/icons/parkingstatus.svg";
import debtIcon from "assets/icons/debtmanagement.svg";
import dailyScheduleIcon from "assets/icons/dailycalendar.svg";
import parkingSettingIcon from "assets/icons/parking.svg";
import timeAttendanceIcon from "assets/icons/timeAttendance.svg";
import userIcon from "assets/icons/user.svg";
import paymentIcon from "assets/icons/payment.svg";
import monthlyPayIcon from "assets/icons/monthlyPay.svg";
import scheduleIcon from "assets/icons/schedule.svg";
import parkingCloseIcon from "assets/icons/parkingCloseIcon.svg";

import { useNavigate } from "react-router-dom";
import SubHeader from "../../../shared/components/SubHeader";
import { setParkingSpaceView } from "features/parking/presentation/store/parkingSlice";
import { STORAGE_KEYS } from "../../../hooks/useAttendanceCheck";
// import ReceiptPrinterEncoder from '@point-of-sale/receipt-printer-encoder';

const MenuManagerPage = () => {
  const { showMenu, alertCheckout } = useSelector((state) => state.header);
  const { user } = useSelector((state) => state.auth);
  const [isManager, setIsManager] = useState(true);
  const [checkinTimeMenu, setCheckinTimeMenu] = useState(true);
  const [checkoutTimeMenu, setCheckoutTimeMenu] = useState(false);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (user?.classificationName == "관제사" || user?.classificationName == "관리자") {
      setIsManager(true);
    } else {
      setIsManager(false);
    }
    const checkinTime = localStorage.getItem(STORAGE_KEYS.CHECKIN_TIME);
    const checkoutTime = localStorage.getItem(STORAGE_KEYS.CHECKOUT_TIME);
    setCheckinTimeMenu(checkinTime);
    setCheckoutTimeMenu(checkoutTime);
    dispatch(setParkingSpaceView("grid"));
  }, []);

  const onNavi = (path) => {
    navigation(path);
  };

  return (
    <div className="employee-management-container mn-employee-management-container">
      {(
        <>
          <div className="menu-section">
            <SubHeader>
              <div
                className={`sub-header-text w-full ${checkinTimeMenu ? " justify-between" : "justify-center"
                  }`}
              > <span className="title-manager">내 출퇴근상태</span>
                {/* {(checkinTimeMenu && !alertCheckout) ? (
                  <span className="title-manager">내 출퇴근상태</span>
                ) : (
                  <span className="title-employee" style={{ padding: '4px 0 3px' }}>어제 퇴근 미등록입니다.</span>
                )} */}
                {checkinTimeMenu && (
                  checkoutTimeMenu ? <span className="htBold sub-header-text-done">퇴근완료</span> : <span className="htBold sub-header-text-main">출근완료</span>
                )}
              </div>
            </SubHeader>

            <div className="menu-title" onClick={() => setIsManager(!isManager)}>근무자 메뉴</div>

            <div className="menu-grid">

              <div
                className="menu-item"
                onClick={() => onNavi("/parking_status")}
              >
                <div className="icon">
                  <img src={parkingStatusIcon} alt="parking Status" />
                </div>
                <div className="label">주차 상황판</div>
              </div>

              <div className="menu-item" onClick={() => onNavi("/parking_unpaid_list")}>
                <div className="icon">
                  <img src={debtIcon} alt="debt management" />
                </div>
                <div className="label">미납관리</div>
              </div>

              <div
                className="menu-item"
                onClick={() => onNavi("/time_attendance")}
              >
                <div className="icon">
                  <img src={timeAttendanceIcon} alt="time attendance" />
                </div>
                <div className="label">출근/퇴근</div>
              </div>

              <div className="menu-item"
                onClick={() => onNavi("/parking_detail_settlement")}
              >
                <div className="icon">
                  <img src={paymentIcon} alt="payment management" />
                </div>
                <div className="label">정산관리</div>
              </div>
              <div className="menu-item"
                onClick={() => onNavi("/parking_closing")}
              >
                <div className="icon">
                  <img src={parkingCloseIcon} alt="payment management" />
                </div>
                <div className="label">일마감</div>
              </div>
              <div className="menu-item"
                onClick={() => onNavi("/parking_payment_monthly")}
              >
                <div className="icon">
                  <img src={monthlyPayIcon} alt="payment management" />
                </div>
                <div className="label">정기권결제</div>
              </div>
              {/* <div
                className="menu-item"
                onClick={() => onNavi("/user_manager_edit")}
              >
                <div className="icon icon-users">
                  <img src={userIcon} alt="user management" />
                </div>
                <div className="label">사용자관리</div>
              </div> */}
              {/* <div
                className="menu-item"
                onClick={() => onNavi("/parking_attendance")}
              >
                <div className="icon">
                  <img src={dailyScheduleIcon} alt="daily schedule" />
                </div>
                <div className="label">출근기록부</div>
              </div> */}
            </div>
          </div>
          {/* {isManager && (
            <div className="menu-section">
              <div className="menu-title mn-menu-title">관리자 메뉴</div>

              <div className="menu-grid">
                <div
                  className="menu-item"
                  onClick={() => onNavi("/schedule_management")}
                >
                  <div className="icon">
                    <img src={scheduleIcon} alt="schedule setting" />
                  </div>
                  <div className="label">스케줄관리</div>
                </div>

                <div
                  className="menu-item"
                  onClick={() => onNavi("/user_manager")}
                >
                  <div className="icon icon-users">
                    <img src={userIcon} alt="user management" />
                  </div>
                  <div className="label">사용자관리</div>
                </div>

                <div
                  className="menu-item"
                  onClick={() => onNavi("/parking_setting_list")}
                >
                  <div className="icon">
                    <img src={parkingSettingIcon} alt="parking setting" />
                  </div>
                  <div className="label">주차장 설정</div>
                </div>
              </div>
            </div>
          )} */}
        </>
      )}
    </div>
  );
};

export default MenuManagerPage;
